(function () {
    'use strict';

    function textSearchFieldConfiguration() {
        return {
            restrict: 'E',
            templateUrl: 'common/directives/templates/textSearchFieldConfiguration.html',
            link: function (scope) {
            }
        };
    }

    textSearchFieldConfiguration.$inject = [];

    angular.module('ecap.common').directive('textSearchFieldConfiguration', textSearchFieldConfiguration);
})();
